module.exports = __webpack_public_path__ + "media/images/brand/twitter-bc434422423586336b5730643654b7a0.svg";